import { c as _c } from "react/compiler-runtime";
import { forwardRef, lazy } from 'react';
const FiltersBar = lazy(() => import('./components/FiltersBar'));
const LayoutBar = lazy(() => import('./components/LayoutBar'));
const TotalCountBar = lazy(() => import('./components/TotalCountBar'));
const ListOptionsBar = (t0, ref) => {
    const $ = _c(24);
    const { activeLayout, setActiveLayout, filterButtons, orderSelect, possibleLayouts, totalCount, showFiltersIntro, showLayoutIntro, className: t1, innerClassName: t2 } = t0;
    const className = t1 === undefined ? "" : t1;
    const innerClassName = t2 === undefined ? "" : t2;
    const computedClassName = `py-2 border-b border-gray-100 flex flex-row justify-center ${className}`;
    const computedInnerClassName = `w-full flex  ${innerClassName} ${filterButtons ? "flex-col xs:flex-row xs:justify-between xs:flex-wrap" : "flex-row justify-between flex-wrap"}`;
    let t3;
    if ($[0] !== totalCount) {
        t3 = typeof totalCount !== "undefined" ? <TotalCountBar totalCount={totalCount}/> : null;
        $[0] = totalCount;
        $[1] = t3;
    }
    else {
        t3 = $[1];
    }
    const totalCountBar = t3;
    let t4;
    if ($[2] !== filterButtons || $[3] !== showFiltersIntro) {
        t4 = filterButtons ? <FiltersBar filterButtons={filterButtons} showFiltersIntro={showFiltersIntro}/> : null;
        $[2] = filterButtons;
        $[3] = showFiltersIntro;
        $[4] = t4;
    }
    else {
        t4 = $[4];
    }
    const filterBar = t4;
    let t5;
    if ($[5] !== activeLayout || $[6] !== possibleLayouts || $[7] !== setActiveLayout || $[8] !== showLayoutIntro) {
        t5 = possibleLayouts && activeLayout && setActiveLayout ? <LayoutBar activeLayout={activeLayout} setActiveLayout={setActiveLayout} possibleLayouts={possibleLayouts} showLayoutIntro={showLayoutIntro}/> : null;
        $[5] = activeLayout;
        $[6] = possibleLayouts;
        $[7] = setActiveLayout;
        $[8] = showLayoutIntro;
        $[9] = t5;
    }
    else {
        t5 = $[9];
    }
    const layoutBar = t5;
    let t6;
    if ($[10] !== orderSelect) {
        t6 = orderSelect ? <div className="flex flex-row flex-grow justify-end">{orderSelect}</div> : null;
        $[10] = orderSelect;
        $[11] = t6;
    }
    else {
        t6 = $[11];
    }
    const orderBar = t6;
    let t7;
    if ($[12] !== layoutBar || $[13] !== orderBar) {
        t7 = !!layoutBar || !!orderBar ? <div className="flex flex-row flex-grow items-center min-h-8">{layoutBar}{orderBar}</div> : null;
        $[12] = layoutBar;
        $[13] = orderBar;
        $[14] = t7;
    }
    else {
        t7 = $[14];
    }
    let t8;
    if ($[15] !== computedInnerClassName || $[16] !== filterBar || $[17] !== t7 || $[18] !== totalCountBar) {
        t8 = <div className={computedInnerClassName}>{totalCountBar}{filterBar}{t7}</div>;
        $[15] = computedInnerClassName;
        $[16] = filterBar;
        $[17] = t7;
        $[18] = totalCountBar;
        $[19] = t8;
    }
    else {
        t8 = $[19];
    }
    let t9;
    if ($[20] !== computedClassName || $[21] !== ref || $[22] !== t8) {
        t9 = <div className={computedClassName} ref={ref}>{t8}</div>;
        $[20] = computedClassName;
        $[21] = ref;
        $[22] = t8;
        $[23] = t9;
    }
    else {
        t9 = $[23];
    }
    return t9;
};
export default forwardRef(ListOptionsBar);
